import React, { Component } from 'react';
import { Select } from 'formsy-react-components';
import Parse from 'parse'

class CompanySelect extends Component {
	constructor(props) {
		super(props)
		this.state = {
            options: []
        }
    }
    
    componentDidMount() {
        let companyQuery = new Parse.Query("Company")

        let options = [{
            value: "",
            label: "Firma auswählen..."
        }]

        companyQuery.ascending("name").limit(1000).find().then(companyObjects => {
            companyObjects.forEach(companyObject => {
                options.push({
                    value: companyObject.id,
                    label: companyObject.get("name")
                })
            })
        }).then(() => {
            this.setState({ options });
        })    
    }

    render() {
        const { name, label, value, ...rest } = this.props

        return (
            <Select
                name={name}
                label={label}
                value={value}
                options={this.state.options}
                {...rest}
            />
        )
    }
}

export default CompanySelect


// WEBPACK FOOTER //
// /src/components/controls/CompanySelect.js